import { render, staticRenderFns } from "./DreamForm.vue?vue&type=template&id=3282503a&scoped=true&"
import script from "./DreamForm.vue?vue&type=script&lang=ts&"
export * from "./DreamForm.vue?vue&type=script&lang=ts&"
import style0 from "./DreamForm.vue?vue&type=style&index=0&id=3282503a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282503a",
  null
  
)

export default component.exports